var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { UserService } from '~/services/management-service/user.service';
var UserList = /** @class */ (function (_super) {
    __extends(UserList, _super);
    function UserList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            roleId: '',
            userName: '',
            realName: '',
            userStatus: ''
        };
        _this.dataSet = [];
        return _this;
    }
    UserList.prototype.refresh = function (id) {
        this.model.roleId = id;
        this.refreshData();
    };
    UserList.prototype.refreshData = function () {
        var _this = this;
        this.userService.getAllUsers(this.model, this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], UserList.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], UserList.prototype, "userService", void 0);
    UserList = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], UserList);
    return UserList;
}(Vue));
export default UserList;
